
import { defineComponent } from "vue"
import EatCookCategories from "@/components/system_settings/EatCookCategories.vue"
export default defineComponent({ components: { EatCookCategories } })
